<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Add Order</h2>
        <form @submit.prevent="submitOrder">
          <!-- Client Dropdown -->
        <select v-model="order.clientId" class="w-full p-2 border rounded-lg mb-4" required>
          <option disabled value="">Select a Client</option>
          <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.name }}</option>
        </select>
          <input v-model="order.clientId" class="w-full p-2 border rounded-lg mb-4" placeholder="Client Name" required />
          <input v-model="order.totalAmount" type="number" class="w-full p-2 border rounded-lg mb-4" placeholder="Total Amount" required />
          <!-- <input v-model="order.status" class="w-full p-2 border rounded-lg mb-4" placeholder="Status" required /> -->
          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Add Order</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  export default {
    data() {
      return {
        order: {
          clientId: '',
          totalAmount: '',
          status: '',
        },
      };
    },
    async mounted() {
      await this.fetchClient();
    },
    computed: {
    ...mapState('clients', {
      clients: state => state.clients,
    })
   },
    methods: {
      ...mapActions('clients',{
      fetchClients : 'fetchClients'
      }),
      ...mapActions('orders', {
        createOrder : 'createOrder',
      }),
      async fetchClient() {
        await this.fetchClients();
      },
      submitOrder() {
        this.$emit('addOrder', this.order);
        this.createOrder(this.order);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
  </script>
  